import { MailFilled } from "@ant-design/icons";
import { Footer } from "antd/es/layout/layout";
import { Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Links } from "../../handlers/enums";

export default function ComponentFooter() {
  const { t } = useTranslation();

  return (
    <Footer className="mt-4 rounded-2xl border border-white/10 bg-custom-grey/50 px-4 py-3 text-custom-white">
      <Space size={8} className="w-full justify-center text-center">
        <a href={Links.MailTo} aria-label={t("contact_mail")}>
          <MailFilled className="text-lg text-custom-blue" />
        </a>
        <Typography.Text className="!text-custom-white/90">
          {t("copyright_date")} © <a href={Links.Vvoids} rel="noreferrer noopener" target="_blank">{t("virtual_voids")}</a>
        </Typography.Text>
      </Space>
    </Footer>
  );
}
